import React from 'react'
import { Icon, Popup, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import map from 'lodash/map'
import capitalize from 'lodash/capitalize'

const packageSizes = ['all', 'small', 'medium', 'large']

export default class PackageSizesButton extends React.PureComponent {
  state = { visible: false, loading: false }

  onChangePackage = async size => {
    try {
      const { order, readOnly } = this.props

      if (readOnly) return

      const branchUid = order.restaurant.branch.key

      this.setState({ visible: false, loading: true })

      const updates = {}

      updates[`orders/${order.key}/package_size`] = size
      updates[`branch_orders/${branchUid}/${order.key}/package_size`] = size

      const err = await firebase
        .database()
        .ref()
        .update(updates)

      if (err) throw err

      this.setState({ loading: false })
    } catch (error) {
      alert(error.message || error)
      this.setState({ loading: false })
    }
  }

  onPopupAction = () => {
    const { visible } = this.state

    this.setState({ visible: !visible })
  }

  renderOptions = () => {
    return map(packageSizes, size => (
      <div style={{ marginBottom: 3 }} key={size}>
        <Button size="tiny" fluid onClick={() => this.onChangePackage(size)}>
          {capitalize(size)}
        </Button>
      </div>
    ))
  }

  renderPopupTrigger = () => {
    const { order } = this.props
    const { loading } = this.state

    if (order.package_size) {
      return (
        <Button
          loading={loading}
          disabled={loading}
          style={{ margin: 0, marginTop: 5, width: 150 }}
          size="mini"
        >
          <Icon name="box" />
          {capitalize(order.package_size)}
        </Button>
      )
    }

    return null
  }

  render() {
    const { visible } = this.state
    const { readOnly, order } = this.props

    if (readOnly && order.package_size) {
      return (
        <React.Fragment>
          <Button size="mini" style={{ margin: 0, marginTop: 5, width: 150 }}>
            <Icon name="box" />
            {capitalize(order.package_size)}
          </Button>
        </React.Fragment>
      )
    }

    return (
      <Popup
        wide
        on="click"
        hideOnScroll
        open={visible}
        position="bottom center"
        onOpen={this.onPopupAction}
        onClose={this.onPopupAction}
        trigger={this.renderPopupTrigger()}
      >
        {this.renderOptions()}
      </Popup>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/ActionButtons/PackageSize.js